import React from "react";
import Wix from "Wix";
import parameters from "../../../config/parameters";
import WrapperDriveItemList from "../wrapperDriveItemList/WrapperDriveItemList";
import Menu from "../menu/Menu";
import SearchDriveApi from "../../api/SearchDriveApi";
import { updateNavigationList, setIsNewFile, setIsNewFileMobile } from "../../../actions/widgetAction";
import { connect } from "react-redux";
import { getFileByFileId, retrieveAllFilesByFolderId } from "../../api/GoogleDriveApi";
import setDataPublic from '../../../actions/dataPublicActions';
import "./DriveItems.scss";
import EditorError from "../editorError/EditorError";
import { injectIntl } from 'react-intl';

/**
 * Get all children and sorts to an array of folders and an array files
 * @param {array} items - all children
 */
const filterFileAndFolder = items => {
  let fileItems = [];
  let  folderItems = [];
  items.forEach(item => {
          if (item !== undefined){
            if (item.mimeType === parameters["TYPE_FOLDER"]) 
            {
                folderItems.push(item);
            }
            else fileItems.push(item);
   }  
  });
  return {
    folderItems: folderItems,
    fileItems: fileItems
  };
};

class DriveItems extends SearchDriveApi {
  constructor(props) {
    super(props);
    this.state = {
      id: props.id ? props.id : "",
      items: [],
      fileItems: [],
      folderItems: [],
      size: props.size,
      searchEvent: false,
      SearchSignleFile: false,
      resultLength: 0,
      type: "file",
      sortBy: props.sortDefault,
      changeMode: props.changeMode,
      searchInput: ''
    };

    this.addNewNavigate = this.addNewNavigate.bind(this);
    this.addFiles = this.addFiles.bind(this);
    this.getFiles = this.getFiles.bind(this);
    this.SortByParam = this.SortByParam.bind(this);
    this.sortByName = this.sortByName.bind(this);
    this.sortName = this.sortName.bind(this);
    this.sortByOwner = this.sortByOwner.bind(this);
    this.sortOwner = this.sortOwner.bind(this);
    this.sortByDate = this.sortByDate.bind(this);
    this.sort = this.sort.bind(this);
    this.sortDate = this.sortDate.bind(this);
    this.first = false;
    this.ascDate = true;
    this.ascOwner = true;
    this.asc = false;

  }
  componentDidMount() {

    if (typeof this.props.id != 'undefined' && this.state.changeMode != this.props.changeMode ) {
        this.openFolder(this.props.id);
    }
    this.setState(
      {
        id: this.props.id,
        resourceKey:this.props.resourceKey,
        activeFileId: this.props.id,
        size:  this.props.size,
        sortDefault: this.props.sortDefault,
        sortBy: this.props.sortDefault,
        SearchSignleFile: this.props.SearchSignleFile ? this.props.SearchSignleFile : false,
        resultLength: this.props.resultLength,
        changeMode: this.props.changeMode,
        listItemFontClass:  this.props.listItemFontClass,
        navigationFontClass: this.props.navigationFontClass
      },
      this.getFiles
    );
  }

  componentWillReceiveProps(newProps) {

    if (typeof newProps.id != 'undefined' && this.state.changeMode != newProps.changeMode ) {
        this.openFolder(newProps.id);
    }
    this.setState(
      {
        id: newProps.id,
        resourceKey:newProps.resourceKey,
        activeFileId: newProps.id,
        size: newProps.size,
        sortDefault: newProps.sortDefault,
        sortBy: newProps.sortDefault,
        SearchSignleFile: newProps.SearchSignleFile ? newProps.SearchSignleFile : false,
        resultLength: newProps.resultLength,
        changeMode: newProps.changeMode,
        listItemFontClass: newProps.listItemFontClass,
        navigationFontClass: newProps.navigationFontClass
      },
      this.getFiles
    );
  }
  /**
   * Set param to sort item
   * @param {*} sortBy
   */
  SortByParam(sortBy) {
    switch (sortBy) {
      case "Name":
        this.sortByName();
        break;
      case "Owner":
        this.sortByOwner();
        break;
      case "Date":
        this.sortByDate();
        break;
      default:
        break;
    }
  }

  /**
   * Sort array by name
   * @param {array} items array to sort
   * @param {boolean} sortA  To sort from A to Z or reverse
   */
  sortName(items, sortA) {
    let first = sortA ? 1 : -1;
    let last = sortA ? -1 : 1;

    return items.sort(function(a, b) {
      let titleA = a.title.toUpperCase();
      let titleB = b.title.toUpperCase();
      return titleA > titleB ? first : titleB > titleA ? last : 0;
    });
  }

  /**
   * Sort array by owner
   * @param {array} items array to sort
   * @param {boolean} sortA  To sort from A to Z or reverse
   */
  sortOwner(items, sortA) {
    let first = sortA ? 1 : -1;
    let last = sortA ? -1 : 1;

    return items.sort(function(a, b) {
      let titleA = a.ownerNames[0].toUpperCase();
      let titleB = b.ownerNames[0].toUpperCase();
      return titleA > titleB ? first : titleB > titleA ? last : 0;
    });
  }

  /**
   * Sort array by date
   * @param {array} items array to sortSort
   */
  sortDate(items, ascDate) {
    let first = ascDate ? 1 : -1;
    let last = ascDate ? -1 : 1;

    return items.sort((a, b) => {
      const dateA = new Date(a.modifiedDate);
      const dateB = new Date(b.modifiedDate);
      return dateB < dateA ? first : dateB > dateA ? last : 0;
    });
  }

  /**
   * func start sort by name and change the sorting direction
   */
  sortByName() {
    this.asc = this.first = !this.first;
    this.sort(this.sortName, this.first, "2");
  }
  /**
   * func start sort by date and change the sorting direction
   */
  sortByDate() {
    this.asc = this.ascDate = !this.ascDate;
    this.sort(this.sortDate, this.ascDate, "1");
  }
  /**
   * func start sort by owner and change the sorting direction
   */
  sortByOwner() {
    this.asc = this.ascOwner = !this.ascOwner;
    this.sort(this.sortOwner, this.ascOwner, "3");
  }
  /**
   * Call to sort function and set the updated data
   * @param {function} func sort function
   * @param {boolean} first sorting direction
   */
  sort(func, first, sortBy) {
    let sortFileItems = func(this.state.fileItems, first);
    let sortFolderItems = func(this.state.folderItems, first);
    this.setState({
      fileItems: sortFileItems,
      folderItems: sortFolderItems,
      sortBy: sortBy
    });
  }

  /**
   * Add folder to navigate list
   * @param {String} idNewNavigate id of folder
   * @param {Object} parent parent of folder
   * @param {String} title title of folder
   */
  addNewNavigate(idNewNavigate, parent, title) {
    let navigateList = this.props.navigateList;
    if (!navigateList) navigateList = {};
    if (!navigateList[idNewNavigate]) {
      navigateList[idNewNavigate] = { parent: parent, title: title };
      this.props.updateNavigationList(navigateList);
    }
  }

  /**
   * Get file/folder selected
   */
  getFiles () { 
    getFileByFileId(this.state.id,this.state.resourceKey, item => {
      if (item) {
        if (item.mimeType === parameters["TYPE_FOLDER"]) {
          this.setState({ type: "folder", driveSelected: item });
          this.addNewNavigate(this.props.id, { id: "" }, item.title);
          retrieveAllFilesByFolderId(item.id,item.resourceKey, this.addFiles );
        } else {
          this.setState({ type: "file", driveSelected: item });
          this.addFiles([item]);
        }
      }
    },false);
  }

  sortBydefault(fileItems) {
    switch (this.props.sortDefault){
      case "1":
        this.asc = false;
        return this.sortDate(fileItems, false)
      case "2":
        this.asc = true;
        return this.sortName(fileItems, true)
      case "3":
        this.asc = true;
        return this.sortOwner(fileItems, true)
    } 
  }
  /**
   * Get files of folder to render on screen.
   * @param {Array} items - array of file to render.
   */
addFiles(items) {
  const itemFilter = filterFileAndFolder(items);
  const fileItems = this.sortBydefault(itemFilter.fileItems, false);
  const folderItems = this.sortBydefault(itemFilter.folderItems, false);

  if (items.length === 0) {
    this.setState({
      items: items,
      fileItems: fileItems,
      folderItems: folderItems,
      emptyFolder: true,
      searchInput: ''
    });
  } else {
    this.setState({
      items: items,
      fileItems: fileItems,
      folderItems: folderItems,
      emptyFolder: false
    });
  }
  }

  /**
   * Open folder selected
   * @param {Object} folder - folder selected
   */
  openFolder(folder) {
    this.addNewNavigate(folder.id, this.state.driveSelected, folder.title);
    this.setState({
      driveSelected: folder,
      items: [],
      fileItems: [],
      folderItems: [],
      SearchSignleFile: false,
      emptyFolder: false,
    });
    retrieveAllFilesByFolderId(folder.id,folder.resourceKey ,this.addFiles);
   }
  
  /**
   * View Loader if search event
   * @param {*} search - event search
   */
  searchEventLoader(search) {
    if (search) this.setState({ SearchSignleFile: true });
    //else this.setState({ SearchSignleFile: false });
    this.setState({ searchEvent : search });
  }

  windowResize = (itemsfilter) => {
    if( Wix.Utils.getViewMode() !== "editor" || itemsfilter.length < 1){
      return;
    }
    const deviceType = Wix.Utils.getDeviceType();
    const itemsLength = itemsfilter.length;
    let height = 0;
    if( deviceType === "mobile" && this.props.isNewFileMobile && window.innerHeight === 272 ){
      height = 85 * itemsLength + 63;
      this.props.setIsNewFileMobile(false);
      Wix.setHeight(height);
    }
    else if(deviceType === "desktop" && this.props.isNewFile) {
      height = 85 * itemsLength + 132;
      this.props.setIsNewFile(false);
      Wix.setHeight(height);
    }
   
  }


  render() {
    const viewMode = Wix.Utils.getViewMode();
    let signal = this.state.type === "file";
    const itemsfilter = this.state.folderItems.concat(this.state.fileItems);
    if (
      this.props.navigateList &&
      Object.keys(this.props.navigateList).length > 1
    ) {
      signal = false;
    } 
    this.windowResize(itemsfilter)
    return (
      <div className={`drive-items${this.state.listItemFontClass}${this.state.navigationFontClass}`}>
        {!signal && this.state.driveSelected ? (
          <Menu
            id={this.props.id}
            resourceKey={this.props.resourceKey}
            driveSelected={this.state.driveSelected}
            addFiles={this.addFiles}
            openFolder={item => this.openFolder(item)}
            searchEvent={search => this.searchEventLoader(search)}
            itemList={this.state.items}
            SearchSignleFile={this.state.SearchSignleFile}
            SortByParam={this.SortByParam}
            sortBy={this.state.sortBy}
            sortAsc={this.asc}
            emptyFolder = {this.state.emptyFolder}
            searchInput={this.state.searchInput}
          />
        ) : null}
        {this.state.private ?
              (
               viewMode==="editor" ?
                <EditorError
                title= {this.props.intl.formatMessage({id: 'widget.notPublicAnymore'})}
                titleInfo =  {this.props.intl.formatMessage({id: 'widget.goTo'})}
                subTitleInfo =  
                {this.props.intl.formatMessage({id: 'widget.permissionsFor'})}
              /> 
                :
                <EditorError  title = {this.props.intl.formatMessage({id: 'widget.oops'})}
                  titleInfo = {this.props.intl.formatMessage({id: 'widget.wrong'})}
               /> 
            ):
            (
                <WrapperDriveItemList
                  openFolder={item => this.openFolder(item)}
                  items={this.state.items}
                  SearchSignleFile={this.state.SearchSignleFile}
                  searchEvent={this.state.searchEvent}
                  fileItems={this.state.fileItems}
                  folderItems={this.state.folderItems}
                  sortBy={this.state.sortBy}
                  sortAsc={this.asc}
                  SortByParam={this.SortByParam}
                  folder={this.state.driveSelected}
                  emptyFolder = {this.state.emptyFolder}
                />
            )   
   
        }
      </div>
    );
  }
}
const mapStateToProps = state => ({
      navigateList: state.widgetReducer.navigationList,
      dataPublic: state.dataPublicReducer.dataPublic,
      isNewFile: state.widgetReducer.isNewFile,
      isNewFileMobile: state.widgetReducer.isNewFileMobile
});

const mapDispatchToProps = dispatch => ({
     updateNavigationList: navigateList => dispatch(updateNavigationList(navigateList)),
     setDataPublic: (dataPublic) => dispatch(setDataPublic(dataPublic)),
     setIsNewFile: isNewFile => dispatch(setIsNewFile(isNewFile)),
     setIsNewFileMobile: isNewFileMobile => dispatch(setIsNewFileMobile(isNewFileMobile)),
});

export default injectIntl(connect(
  mapStateToProps,
  mapDispatchToProps
)(DriveItems));


// WEBPACK FOOTER //
// ./src/widget/components/driveItems/DriveItems.js